import { useQuery } from "@tanstack/react-query";
import { ErrorResponse } from "App";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";

import { getSupplierById } from "../api/getSupplierById";

export const useGetSupplierById = (id: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.supplier_by_id, id],
    queryFn: () => getSupplierById(id),
    enabled: Boolean(id),
    onError: (error: ErrorResponse) => errorModal(error),
    staleTime: Infinity,
    useErrorBoundary: true
  });
};
